import React from 'react';
import PropTypes from 'prop-types';

const Edit = ({ color = '#8C949C' }) => (
    <svg
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="btn_edit_16px" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Svg-Icons/18px-(All-icons)/trash-filled-18px">
                <rect id="Bounds" fill="#D8D8D8" opacity="0" x="0" y="0" width="16" height="16" />
                <path
                    d="M1,12.0837384 L1,15 L3.91626163,15 L12.5172893,6.39897236 L9.60102764,3.48271073 L1,12.0837384 Z M14.7725316,4.14373004 C15.0758227,3.84043883 15.0758227,3.35050687 14.7725316,3.04721566 L12.9527843,1.22746841 C12.6494931,0.924177198 12.1595612,0.924177198 11.85627,1.22746841 L10.4331343,2.65060409 L13.3493959,5.56686572 L14.7725316,4.14373004 Z"
                    id="Shape"
                    fill={color}
                    fillRule="nonzero"
                    className="icon-color"
                />
            </g>
        </g>
    </svg>
);

Edit.propTypes = {
    color: PropTypes.string,
};

export default Edit;
